/**
 * Barcode formats
 */
export var BarcodeFormat;
(function (BarcodeFormat) {
    // 2D Codes
    BarcodeFormat["QR_CODE"] = "QR_CODE";
    BarcodeFormat["DATA_MATRIX"] = "DATA_MATRIX";
    BarcodeFormat["AZTEC"] = "AZTEC";
    BarcodeFormat["PDF_417"] = "PDF_417";
    BarcodeFormat["MAXICODE"] = "MAXICODE";
    // 1D Product Codes
    BarcodeFormat["EAN_13"] = "EAN_13";
    BarcodeFormat["EAN_8"] = "EAN_8";
    BarcodeFormat["UPC_A"] = "UPC_A";
    BarcodeFormat["UPC_E"] = "UPC_E";
    // 1D Industrial Codes
    BarcodeFormat["CODE_128"] = "CODE_128";
    BarcodeFormat["CODE_39"] = "CODE_39";
    BarcodeFormat["CODE_93"] = "CODE_93";
    BarcodeFormat["CODABAR"] = "CODABAR";
    BarcodeFormat["ITF"] = "ITF";
    BarcodeFormat["ITF_14"] = "ITF_14";
    // Specialty Codes
    BarcodeFormat["MSI"] = "MSI";
    BarcodeFormat["MSI_PLESSEY"] = "MSI_PLESSEY";
    BarcodeFormat["PHARMACODE"] = "PHARMACODE";
    BarcodeFormat["RSS_14"] = "RSS_14";
    BarcodeFormat["RSS_EXPANDED"] = "RSS_EXPANDED";
})(BarcodeFormat || (BarcodeFormat = {}));
/**
 * QR code types
 */
export var QRType;
(function (QRType) {
    QRType["WEBSITE"] = "website";
    QRType["PDF"] = "pdf";
    QRType["IMAGES"] = "images";
    QRType["VIDEO"] = "video";
    QRType["WIFI"] = "wifi";
    QRType["MENU"] = "menu";
    QRType["BUSINESS"] = "business";
    QRType["VCARD"] = "vcard";
    QRType["MP3"] = "mp3";
    QRType["APPS"] = "apps";
    QRType["LINKS_LIST"] = "links_list";
    QRType["COUPON"] = "coupon";
    QRType["FACEBOOK"] = "facebook";
    QRType["INSTAGRAM"] = "instagram";
    QRType["SOCIAL_MEDIA"] = "social_media";
    QRType["WHATSAPP"] = "whatsapp";
    QRType["TEXT"] = "text";
    QRType["EMAIL"] = "email";
    QRType["SMS"] = "sms";
    QRType["PHONE"] = "phone";
    QRType["LOCATION"] = "location";
    QRType["EVENT"] = "event";
})(QRType || (QRType = {}));
export var Directory;
(function (Directory) {
    Directory["Documents"] = "DOCUMENTS";
    Directory["Downloads"] = "DOWNLOADS";
    Directory["External"] = "EXTERNAL";
    Directory["ExternalStorage"] = "EXTERNAL_STORAGE";
})(Directory || (Directory = {}));
//# sourceMappingURL=definitions.js.map